var AlertsType = {
    Or : 1,
    And : 2,
    Both : 3
 }
 export default AlertsType;